import { PartnerApplicationFormNavigation } from '~domains/partner-application/@x/profile';
import { PersonMachineContext } from '~domains/profile/entities/person';

import { ScreenAsidePortal } from '~shared/ui/screen';

import { ProfileFormNavigation } from './profile-form-navigation';

import { getActiveProfileNavStepId } from '../lib/get-active-profile-nav-step';

export const ProfileFormNavigationConnected = () => {
  const activeProfileStepId = PersonMachineContext.useSelector(
    getActiveProfileNavStepId
  );
  const isStart = PersonMachineContext.useSelector((state) =>
    state.matches('start')
  );

  if (isStart) {
    return null;
  }

  return (
    <ScreenAsidePortal>
      <nav
        aria-label="Partner application form navigation"
        className="flex flex-col"
      >
        <ProfileFormNavigation activeStepId={activeProfileStepId} />
        <PartnerApplicationFormNavigation />
      </nav>
    </ScreenAsidePortal>
  );
};
